import {encrypt,decrypt} from './crypto_js.js'
import {isEmpty} from "./comjs";

/**
 * 设置本地缓存同步
 * @param {String} key 键
 * @param {String|Object|Array} data 值
 * @param {Number} expirationtime 过期时间单位毫秒
 */
export const setCache = (key,data,expirationtime)=>{
    if(isEmpty(key)){
        return;
    }
    let storeData = {
        data:data,
        startTime : new Date().getTime(),
        expires:expirationtime?expirationtime:''
    }
    let strData = encrypt(JSON.stringify(storeData));
    localStorage.setItem(key,strData);
}

/**
 * 获取本地的缓存
 * @param key 键
 * @returns {string|*}
 */
export const getCache = (key)=>{
    if(isEmpty(key)){
        return '';
    }
    let storeData = localStorage.getItem(key);
    if(isEmpty(storeData)){
        delCache(key);
        return '';
    }
    //数据解密
    storeData = decrypt(storeData);
    try{
        storeData = JSON.parse(storeData)
    }catch (e) {
        delCache(key);
        return '';
    }
    if(storeData.expires !== undefined && storeData.expires !== null && storeData.expires !== ''){
        let nowData = new Date().getTime();
        //判断时间差
        if((nowData - storeData.startTime) > storeData.expires){
            delCache(key);
            return '';
        }else{
            return storeData.data;
        }
    }else{
        return storeData.data;
    }
}

/**
 * 获取带有过期时间的缓存
 * @param key
 * @returns {{val: string, type: string}|{val, type: string}}
 */
export const getExpiresCache = (key)=>{
    if(isEmpty(key)){
        return {val:'',type:'empty'};
    }
    let storeData = localStorage.getItem(key);
    if(isEmpty(storeData)){
        delCache(key);
        return {val:'',type:'empty'};
    }
    //数据解密
    storeData = decrypt(storeData);
    try{
        storeData = JSON.parse(storeData)
    }catch (e) {
        delCache(key);
        return {val:'',type:'empty'};
    }
    if(storeData.expires !== undefined && storeData.expires !== null && storeData.expires !== ''){
        let nowData = new Date().getTime();
        //判断时间差
        if((nowData - storeData.startTime) > storeData.expires){
            delCache(key);
            return {val:'',type:'expires'};
        }else{
            return {val:storeData.data,type:'effective'};
        }
    }else{
        return {val:storeData.data,type:'effective'};
    }
}


/**
 * 删除缓存
 * @param {String} key
 */
export const delCache = (key)=>{
    if(isEmpty(key)){
        return;
    }
    try{
        localStorage.removeItem(key)
    }catch (e){
        console.log(e)
    }
}

/**
 * 清除系统的所有缓存信息
 */
export const clearAll= ()=>{
    try{
        localStorage.clear();
    }catch (e){
        console.log(e)
    }
}
